import React, { useState, useMemo } from 'react';
import { Modal, Form } from 'react-bootstrap';
import HowToItemCard from './HowToItemCard';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

const HowToItemList = ({ items = [], onUpdate, onDelete, onUpdateOrder, readOnly = false }) => {
  const [searchTerm, setSearchTerm] = useState('');
	const [selectedVideo, setSelectedVideo] = useState(null);

  const filteredItems = useMemo(() => {
    if (!searchTerm) return items;
    return items.filter((item) =>
      item.subject.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [items, searchTerm]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reordered = Array.from(filteredItems);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    onUpdateOrder(reordered);
  };

  return (
    <>
      <Form.Control
        type="text"
        placeholder="Search items..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="mb-3"
      />

      {filteredItems.length === 0 && (
        <p className="text-muted">No items match your search.</p>
      )}

      {readOnly ? (
        <div className="d-flex flex-column gap-3">
          {filteredItems.map((item) => (
            <HowToItemCard
              key={item.id}
              readOnly={readOnly}
              item={item}
              onUpdate={onUpdate}
              onDelete={onDelete}
              onPlayVideo={(video) => setSelectedVideo(video)}
            />
          ))}
        </div>
      ) : (
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="howto-list">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="d-flex flex-column gap-3"
              >
                {filteredItems.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <HowToItemCard
                          readOnly={readOnly}
                          item={item}
													onPlayVideo={(video) => setSelectedVideo(video)}
                          onUpdate={onUpdate}
                          onDelete={onDelete}
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
			<Modal
        show={!!selectedVideo}
        onHide={() => {
          const videoElement = document.querySelector('video');
          if (videoElement) videoElement.pause();
          setSelectedVideo(null);
        }}
        centered
        size="lg"
        backdrop="static"
        className="d-flex align-items-center justify-content-center"
        dialogClassName="w-100 m-0"
        contentClassName="bg-dark text-light border-0 rounded-4"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title>{selectedVideo?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 d-flex justify-content-center align-items-center">
          {selectedVideo && (
            <video
              src={selectedVideo.url}
              controls
              autoPlay
              className="w-100 rounded-3"
              style={{ maxHeight: '90vh', backgroundColor: '#000' }}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HowToItemList;
